import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CustomFieldOption } from 'src/app/core/models/custom-fields.models';

export const customFieldOptionValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const option: CustomFieldOption = control.value;
  return !option?.label ? { customFieldOptionValidator: true } : null;
};
